module.exports = __webpack_public_path__ + "static/media/therapies-to-avoid-red.1cd395b7.svg";